<template>
    <card-wrapper :title="Lang.get('employerdashboard::pages/employee/details.title', {fullname: employee.fullname})"
                 :subtitle="Lang.get('employerdashboard::pages/employee/details.subtitle')">
        <template v-slot:nav aria-label="breadcrumb">
            <ol class="breadcrumb font-poppins font-weight-light font-size-14 color-blue px-0 bg-transparent">
                <li class="breadcrumb-item">
                    <a
                        :href="route('nl.employerdashboard.employees.overview', $page.props.auth.user.selected_company.uuid)"
                        class="font-poppins font-weight-semibold color-blue">
                        {{ Lang.get('employerdashboard::pages/employee/breadcrumb.overview') }}</a>
                </li>
                <li class="breadcrumb-item">
                    <a
                        :href="route('nl.employerdashboard.employee.profile', {company_as_uuid: $page.props.auth.user.selected_company.uuid, employee_uuid: employee.uuid})"
                        class="font-poppins font-weight-semibold color-blue">
                        {{ Lang.get('employerdashboard::pages/employee/breadcrumb.profile') }}</a>
                </li>
                <li class="breadcrumb-item color-blue" aria-current="page">
                    {{ Lang.get('employerdashboard::pages/employee/breadcrumb.details') }}</li>
            </ol>
        </template>

        <div class="row mt-5" v-if="employee.is_disabled_from_participation">
            <div class="col-8 mb-4">
                <div class="alert alert-warning">
                    <i class="fa fa-exclamation-circle pr-2"></i> Deze medewerker is geanonimiseerd
                    <p class="pt-2">
                        <strong>{{ Lang.get('employerdashboard::pages/employee/profile.explanation') }}:</strong><br />
                        {{ Lang.get('employerdashboard::pages/employee/profile.is_disabled_from_participation', {
                        reason: employee.disabled_from_participation_reason,
                        reference: employee.disabled_from_participation_reference,
                    }) }}
                    </p>
                </div>
            </div>
        </div>

        <card-layout size="large" v-if="!employee.is_disabled_from_participation">
            <div class="form-row mt-3 mx-3">
                <div class="form-group col-12">
                    <text-input
                        v-model="form.corporate_key"
                        :label="'CorporateKey'"
                        :readOnly="true"
                        :labelOnTheLeft="true"
                        disabled="disabled"
                    />
                </div>
                <div class="form-group col-12">
                    <text-input
                        v-model="form.email"
                        :label="'BusinessEmailAddress'"
                        :readOnly="true"
                        :labelOnTheLeft="true"
                        disabled="disabled"
                    />
                </div>
                <div class="form-group col-12">
                    <text-input
                        v-model="form.is_budget_entitlement"
                        :label="'IsBudgetEntitlement'"
                        :readOnly="true"
                        :labelOnTheLeft="true"
                        disabled="disabled"
                    />
                </div>
                <div class="form-group col-12">
                    <text-input
                        v-model="form.start_date"
                        :label="'StartDate'"
                        :readOnly="true"
                        :labelOnTheLeft="true"
                        disabled="disabled"
                    />
                </div>
                <div class="form-group col-12">
                    <text-input
                        v-model="form.end_date"
                        :label="'EndDate'"
                        :readOnly="true"
                        :labelOnTheLeft="true"
                        disabled="disabled"
                    />
                </div>
                <div class="form-group col-12">
                    <text-input
                        v-model="form.is_release_budget"
                        :label="'IsReleaseBudget'"
                        :readOnly="true"
                        :labelOnTheLeft="true"
                        disabled="disabled"
                    />
                </div>
                <div class="form-group col-12">
                    <text-input
                        v-model="form.cost_center"
                        :label="'CostCenter'"
                        :readOnly="true"
                        :labelOnTheLeft="true"
                        disabled="disabled"
                    />
                </div>
                <div class="form-group col-12">
                    <text-input
                        v-model="form.year_of_birth"
                        :label="'YearOfBirth'"
                        :readOnly="true"
                        :labelOnTheLeft="true"
                        disabled="disabled"
                    />
                </div>
                <div class="form-group col-12">
                    <text-input
                        v-model="form.first_letter"
                        :label="'FirstLetterFirstName'"
                        :readOnly="true"
                        :labelOnTheLeft="true"
                        disabled="disabled"
                    />
                </div>
                <div class="form-group col-12">
                    <text-input
                        v-model="form.preferred_language"
                        :label="'PreferredLanguage'"
                        :readOnly="true"
                        :labelOnTheLeft="true"
                        disabled="disabled"
                    />
                </div>
                <div class="form-group col-12">
                    <text-input
                        v-model="form.is_starting_budget"
                        :label="'IsStartingBudget'"
                        :readOnly="true"
                        :labelOnTheLeft="true"
                        disabled="disabled"
                    />
                </div>
                <div class="form-group col-12">
                    <text-input
                        v-model="form.is_additional_budget"
                        :label="'IsAdditionalBudget'"
                        :readOnly="true"
                        :labelOnTheLeft="true"
                        disabled="disabled"
                    />
                </div>
                <div class="form-group col-12">
                    <text-input
                        v-model="form.account_activation_code"
                        label='Activation Code'
                        :readOnly="true"
                        :labelOnTheLeft="true"
                        disabled="disabled"
                    />
                </div>

            </div>
        </card-layout>

        <div class="col-12 col-md-4 mb-4">
            <div class="row" v-if="$page.props.auth.isCompanyProviderManually">
                <div class="col-12 mb-4">
                    <inertia-link
                        class="btn btn-primary font-poppins font-weight-bold btn-orange border-radius-19 px-4"
                        :href="route('nl.employerdashboard.employee.edit', {
                            'company_as_uuid': this.$page.props.auth.user.selected_company.uuid, 'employee_uuid': employee.uuid})">
                        {{ Lang.get('employerdashboard::shared.edit_employee') }}
                    </inertia-link>
                </div>
            </div>

            <div class="row" v-if="!$page.props.auth.isCompanyProviderManually">
                <div class="col-12 mb-4">
                    <div class="card h-100 border-radius-8 shadow">
                        <div class="card-body">
                            <h4 class="card-title font-poppins font-weight-extrabold color-blue font-size-14">
                                {{ Lang.get('employerdashboard::pages/employee/details.instructions_view_only.title') }}
                            </h4>
                            <div class="card-text color-dark-blue font-size-14">
                                {{ Lang.get('employerdashboard::pages/employee/details.instructions_view_only.description', {'provider': $page.props.auth.companyProvider}) }}
                                <br/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </card-wrapper>
</template>

<script>
import CardWrapper from '@/Shared/CardWrapper';
import CardLayout from "@/Shared/CardLayout";
import TextInput from "@/Shared/TextInput";
import SelectInput from "@/Shared/SelectInput";

export default {
    metaInfo() {
        return {
            title: Lang.get('employerdashboard::pages/employee/details.title', {fullname: this.employee.fullname}),
        }
    },
    components: {
        CardWrapper,
        CardLayout,
        SelectInput,
        TextInput,
    },
    props: {
        errors: Object,
        employee: Object
    },
    data() {
        return {
            isValidated: false,
            contract: false,
            form: {
                corporate_key: this.employee.corporate_key,
                email: this.employee.email,
                is_budget_entitlement: this.employee.is_budget_entitlement,
                start_date: this.employee.start_date,
                end_date: this.employee.end_date,
                is_release_budget: this.employee.is_release_budget,
                cost_center: this.employee.cost_center,
                year_of_birth: this.employee.year_of_birth,
                first_letter: this.employee.first_letter,
                preferred_language: this.employee.preferred_language,
                is_starting_budget: this.employee.is_starting_budget,
                is_additional_budget: this.employee.is_additional_budget,
                account_activation_code: this.employee.account_activation_code,
            },
        }
    },
}
</script>
